import { useDispatch, useSelector } from 'react-redux';
import {
  fetchGetCredential,
  fetchPostCredential,
  fetchPutCredential,
  fetchDeleteCredential,
  cleanUpCredential,
  cleanUpMessageCredential
} from 'state-managament/credential.slice';

export default function useCredential(project) {
  const { error, success, isLoaded, data } = useSelector((state) => state.credential);
  const dispatch = useDispatch();

  const cleanUp = () => dispatch(cleanUpCredential());
  const cleanUpMessage = () => dispatch(cleanUpMessageCredential());
  const getCredential = (args) => dispatch(fetchGetCredential(args));
  const postCredential = (args) => dispatch(fetchPostCredential(args));
  const deleteCredential = (args) => dispatch(fetchDeleteCredential(args));
  const putCredential = (args) => dispatch(fetchPutCredential(args));

  return {
    error,
    success,
    isLoaded,
    data,
    cleanUp,
    cleanUpMessage,
    getCredential,
    postCredential,
    deleteCredential,
    putCredential,
  };

}
